const SUGGESTED_QUESTIONS = [
  "Combien coûte un écran iPhone 13 ?",
  "Vous ouvrez le dimanche ?",
  "Réparation MacBook Air M2 ?",
  "Comment prendre RDV ?",
  "Joystick drift PS5 ?",
];

export const SuggestedQuestions = ({ onPick }) => (
  <div className="px-3 py-2 bg-white border-t border-slate-200">
    <div className="flex flex-wrap gap-2">
      {SUGGESTED_QUESTIONS.map((q) => (
        <button
          key={q}
          type="button"
          onClick={() => onPick(q)}
          data-testid={`chatbot-suggest-${q.slice(0, 20)}`}
          className="text-xs px-3 py-1.5 rounded-full bg-slate-100 hover:bg-red-50 hover:text-red-700 text-slate-700 transition-colors"
        >
          {q}
        </button>
      ))}
    </div>
  </div>
);
